<template>
  <div class="container-fluid">
    <div id="brs" class="contents">
      <section class="adv mt-0">
        <h6 class="sub-title">
          {{ $t("title.brandroom.fittingadvertisingstatus") }}
        </h6>
        <div class="row g-0">
          <div class="col-sm-5 col-md-4">
            <div
              class="col adv-item adv-video"
              :class="{
                'has-item': fittingsaleview.adinfo.ad_mov_info.fit_ad_mov,
              }"
            >
              <video
                class="ratio"
                controls
                autoplay
                muted
                v-if="fittingsaleview.adinfo.ad_mov_info.fit_ad_mov"
              >
                <source
                  v-if="fittingsaleview.adinfo.ad_mov_info.fit_ad_mov"
                  type="video/mp4"
                  :src="fittingsaleview.adinfo.ad_mov_info.fit_ad_mov | get_img"
                />
                {{
                  $t(
                    "text.brandroom.Your browser does not support the video tag."
                  )
                }}
              </video>
            </div>
          </div>
          <div class="col-sm-7 col-md-8 flex-wrap">
            <div
              class="col-12 adv-item adv-title justify-content-center mb-2"
              :class="{
                'has-item': fittingsaleview.adinfo.ad_title_info.fit_ad_img,
              }"
            >
              <img
                v-if="fittingsaleview.adinfo.ad_title_info.fit_ad_img"
                class="img-fluid align-self-center py-2 py-sm-4 bg-white"
                :src="fittingsaleview.adinfo.ad_title_info.fit_ad_img | get_img"
              />
            </div>
            <div class="row g-0 flex-grow-1">
              <div
                class="col adv-item adv-goods flex-sm-wrap"
                :class="{
                  'has-item': fittingsaleview.adinfo.ad_img1_info.fit_ad_img,
                }"
              >
                <img
                  v-if="fittingsaleview.adinfo.ad_img1_info.fit_ad_img"
                  :src="
                    fittingsaleview.adinfo.ad_img1_info.fit_ad_img | get_img
                  "
                />
                <p
                  class="goods-name"
                  v-if="fittingsaleview.adinfo.ad_img1_info.fit_ad_img"
                >
                  <span>{{
                    fittingsaleview.adinfo.ad_img1_info.fit_ad_title
                  }}</span>
                </p>
              </div>

              <div
                class="col adv-item adv-goods mx-0 mx-sm-2 flex-sm-wrap"
                :class="{
                  'has-item': fittingsaleview.adinfo.ad_img2_info.fit_ad_img,
                }"
              >
                <img
                  v-if="fittingsaleview.adinfo.ad_img2_info.fit_ad_img"
                  :src="
                    fittingsaleview.adinfo.ad_img2_info.fit_ad_img | get_img
                  "
                />
                <p
                  class="goods-name"
                  v-if="fittingsaleview.adinfo.ad_img2_info.fit_ad_img"
                >
                  <span>{{
                    fittingsaleview.adinfo.ad_img2_info.fit_ad_title
                  }}</span>
                </p>
              </div>
              <div
                class="col adv-item adv-goods flex-sm-wrap"
                :class="{
                  'has-item': fittingsaleview.adinfo.ad_img3_info.fit_ad_img,
                }"
              >
                <img
                  v-if="fittingsaleview.adinfo.ad_img3_info.fit_ad_img"
                  :src="
                    fittingsaleview.adinfo.ad_img3_info.fit_ad_img | get_img
                  "
                />
                <p
                  class="goods-name"
                  v-if="fittingsaleview.adinfo.ad_img3_info.fit_ad_img"
                >
                  <span>{{
                    fittingsaleview.adinfo.ad_img3_info.fit_ad_title
                  }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section>
        <h6 class="sub-title">{{ $t("title.brandroom.buyer_infromation") }}</h6>
        <div
          class="row g-0 row-cols-2 row-cols-md-4 row-cols-lg-6- table-type header-col"
        >
          <div
            class="col col-lg-1 justify-content-center px-0 border-bottom border-lg-0"
          >
            {{ $t("title.common.nickname") }}
          </div>
          <div class="col border-bottom border-lg-0 align-self-center">
            <MemberInfo
              :nickname="fittingsaleview.memberinfo.membername"
              :memberno="fittingsaleview.memberinfo.memberno"
            />
            <!-- <span class="material-icons-outlined ms-1 fs-6">help_outline</span> -->
          </div>
          <div
            class="col col-lg-1 justify-content-center px-0 border-bottom border-lg-0"
          >
            {{ $t("title.brandroom.order_date") }}
          </div>
          <div class="col border-bottom border-lg-0 align-self-center">
            <span class="text-date">{{
              fittingsaleview.memberinfo.orderdate
            }}</span>
          </div>
          <div class="col col-lg-1 justify-content-center px-0 border-bottom-0">
            {{ $t("title.common.location") }}
          </div>
          <div class="col-md-9 col-lg align-self-center">
            <span class="shop-name">{{
              fittingsaleview.memberinfo.shopname
            }}</span>
          </div>
        </div>
      </section>

      <section>
        <h6 class="sub-title">
          <span class="brand-name fw-bold">{{
            fittingsaleview.goodsinfo.fit_brand_nm
          }}</span
          >{{ $t("text.brandroom.recommended_by") }}
          <span class="text-green">{{ $t("title.brandroom.permium") }}</span>
        </h6>
        <div class="card border-0">
          <div class="row g-0 table-type header-col">
            <div class="col-sm-3">
              <div
                class="d-flex flex-fill justify-content-center h-100 bg-white"
              >
                <img
                  :src="fittingsaleview.goodsinfo.fit_goods_image1 | get_img"
                  class="img-fluid rounded-0"
                />
              </div>
            </div>
            <div class="col-sm-9 d-flex flex-column align-items-stretch">
              <div class="card-body px-0 px-sm-3">
                <h4 class="card-title">
                  {{ fittingsaleview.goodsinfo.fit_goods_nm }}
                </h4>
                <div class="row g-0 row-cols-1 row-cols-sm-2">
                  <div
                    class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 fw-bold text-black"
                  >
                    {{ $t("title.brandroom.price") }}
                  </div>
                  <div class="col-sm-8 py-0 py-sm-2">
                    <h5 class="text-price">
                      &#8361;
                      {{ fittingsaleview.answerinfo.fit_sale_price | comma }}
                    </h5>
                  </div>

                  <div
                    class="col-sm-4 mt-2 mt-sm-0 py-0 py-sm-2 border-top-sm fw-bold text-black"
                  >
                    {{ $t("title.brandroom.shop_price") }}
                  </div>
                  <div class="col-sm-8 py-0 py-sm-2 border-top-sm">
                    <h5 class="text-price">
                      &#8361;
                      {{ fittingsaleview.answerinfo.fit_shop_price | comma }}
                    </h5>
                  </div>

                  <div
                    class="col-sm-4 mt-3 mt-sm-0 py-0 py-sm-2 border-top-sm fw-bold text-black"
                  >
                    {{ $t("title.brandroom.benefit") }}
                  </div>
                  <div class="col-sm-8 py-0 py-sm-2 border-top-sm">
                    {{ fittingsaleview.goodsinfo.fit_goods_info }}
                    <!-- 미등록 -->
                  </div>
                </div>
              </div>
              <!-- //card-body -->
              <!-- <div
                      class="card-footer px-0 px-sm-3 py-0 bg-transparent border-0 rounded-0"
                    >
                      <div
                        class="btn-bottom-wrapper mt-2 mb-4 mt-sm-0 mb-sm-3"
                      >
                        <b-button
                          size="md"
                          variant="primary"
                          aria-label="제품구매"
                        >
                          제품구매
                        </b-button>
                      </div>
                    </div> -->
              <!-- //card-footer -->
            </div>
          </div>
        </div>
      </section>

      <section>
        <h6 class="sub-title">{{ $t("title.brandroom.goods_detail") }}</h6>
        <div class="row g-0 table-type header-col">
          <img
            v-if="fittingsaleview.goodsinfo.fit_goods_image2"
            :src="fittingsaleview.goodsinfo.fit_goods_image2 | get_img"
            class="img-fluid rounded-0"
          />
          <img
            v-if="fittingsaleview.goodsinfo.fit_goods_image3"
            :src="fittingsaleview.goodsinfo.fit_goods_image3 | get_img"
            class="img-fluid rounded-0"
          />
        </div>
      </section>

      <section class="reg-spec">
        <h6 class="sub-title">{{ $t("title.brandroom.club_spec") }}</h6>
        <b-table-simple responsive table-class="border-0">
          <b-thead>
            <b-tr>
              <b-th sticky-column>{{ $t("title.brandroom.club_type") }}</b-th>
              <b-th
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clubnotype' + idx"
              >
                {{
                  fittingsaleview.clubtypelist.find(
                    (v) => v.clubtype_code == val.fit_club_nm
                  ).clubtype_code_name
                }}
              </b-th>
            </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr>
              <b-th sticky-column>{{ $t("title.brandroom.loft2") }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clubloft' + idx"
              >
                {{ val.fit_club_loft }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{ $t("title.brandroom.lie2") }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clublie' + idx"
              >
                {{ val.fit_club_lie }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{
                $t("title.brandroom.headvolumecm")
              }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clubheadvolume' + idx"
              >
                {{ val.fit_club_headvolume }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{ $t("title.brandroom.fpmm") }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clubfp' + idx"
                >{{ val.fit_club_fp }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column>{{ $t("title.brandroom.lengthinch") }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clublength' + idx"
              >
                {{ val.fit_club_length }}
              </b-td>
            </b-tr>
            <b-tr>
              <b-th sticky-column rowspan="5">
                <div class="sticky-column-rowspan">
                  <div>{{ $t("title.brandroom.balance") }}</div>
                  <div class="flex-column">
                    <div
                      v-if="
                        fittingsaleview.answerinfo.fit_balance1 ==
                        fittingsaleview.answerinfo.fit_goods_balance
                      "
                    >
                      {{
                        fittingsaleview.answerinfo.fit_balance1 | get_balance
                      }}
                    </div>
                    <div
                      v-if="
                        fittingsaleview.answerinfo.fit_balance2 ==
                        fittingsaleview.answerinfo.fit_goods_balance
                      "
                    >
                      {{
                        fittingsaleview.answerinfo.fit_balance2 | get_balance
                      }}
                    </div>
                    <div
                      v-if="
                        fittingsaleview.answerinfo.fit_balance3 ==
                        fittingsaleview.answerinfo.fit_goods_balance
                      "
                    >
                      {{
                        fittingsaleview.answerinfo.fit_balance3 | get_balance
                      }}
                    </div>
                    <div
                      v-if="
                        fittingsaleview.answerinfo.fit_balance4 ==
                        fittingsaleview.answerinfo.fit_goods_balance
                      "
                    >
                      {{
                        fittingsaleview.answerinfo.fit_balance4 | get_balance
                      }}
                    </div>
                    <div
                      v-if="
                        fittingsaleview.answerinfo.fit_balance5 ==
                        fittingsaleview.answerinfo.fit_goods_balance
                      "
                    >
                      {{
                        fittingsaleview.answerinfo.fit_balance5 | get_balance
                      }}
                    </div>
                  </div>
                </div>
              </b-th>
              <template
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
              >
                <b-td
                  :key="'p_clubflextitle1' + idx"
                  v-if="
                    fittingsaleview.answerinfo.fit_balance1 ==
                    fittingsaleview.answerinfo.fit_goods_balance
                  "
                >
                  {{ val.fit_club_balance1 }}
                </b-td>
              </template>
            </b-tr>
            <b-tr>
              <template
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
              >
                <b-td
                  :key="'p_clubflextitle2' + idx"
                  v-if="
                    fittingsaleview.answerinfo.fit_balance2 ==
                    fittingsaleview.answerinfo.fit_goods_balance
                  "
                >
                  {{ val.fit_club_balance2 }}
                </b-td>
              </template>
            </b-tr>
            <b-tr>
              <template
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
              >
                <b-td
                  :key="'p_clubflextitle3' + idx"
                  v-if="
                    fittingsaleview.answerinfo.fit_balance3 ==
                    fittingsaleview.answerinfo.fit_goods_balance
                  "
                >
                  {{ val.fit_club_balance3 }}
                </b-td>
              </template>
            </b-tr>
            <b-tr>
              <template
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
              >
                <b-td
                  :key="'p_clubflextitle4' + idx"
                  v-if="
                    fittingsaleview.answerinfo.fit_balance4 ==
                    fittingsaleview.answerinfo.fit_goods_balance
                  "
                >
                  {{ val.fit_club_balance4 }}
                </b-td>
              </template>
            </b-tr>
            <b-tr>
              <template
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
              >
                <b-td
                  :key="'p_clubflextitle5' + idx"
                  v-if="
                    fittingsaleview.answerinfo.fit_balance5 ==
                    fittingsaleview.answerinfo.fit_goods_balance
                  "
                >
                  {{ val.fit_club_balance5 }}
                </b-td>
              </template>
            </b-tr>
            <b-tr>
              <b-th sticky-column class="border-0">{{
                $t("title.brandroom.totalweightgram")
              }}</b-th>
              <b-td
                v-for="(val, idx) in fittingsaleview.answerinfo.ansclublist"
                :key="'p_clubweight' + idx"
              >
                {{ val.fit_club_weight }}
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </section>

      <section class="reg-etc">
        <div class="row gx-4 gy-5 border-0">
          <div class="col-lg-6 d-flex flex-column">
            <h6 class="sub-title">{{ $t("title.brandroom.shaft_spec") }}</h6>
            <div
              class="card h-100"
              v-if="fittingsaleview.shaftinfo.fit_goods_shaft_pk"
            >
              <div class="card-body p-0">
                <p class="card-title">
                  {{ fittingsaleview.shaftinfo.fit_goods_shaft_nm }}
                  /
                  {{
                    fittingsaleview.shaftinfo.fit_shaft_material
                      | get_shaft_material
                  }}
                </p>
                <img
                  :src="
                    fittingsaleview.shaftinfo.fit_goods_shaft_image1 | get_img
                  "
                  class="card-img-top rounded-0"
                  alt="샤트프"
                />
              </div>
              <div class="card-footer">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t("title.brandroom.strength") }}</th>
                      <th scope="col">{{ $t("title.brandroom.weightg") }}</th>
                      <th scope="col">{{ $t("title.brandroom.torque2") }}</th>
                      <th scope="col">{{ $t("title.brandroom.kickpoint") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{
                          fittingsaleview.shaftinfo.fit_goods_shaft_balance
                            | get_balance
                        }}
                      </td>
                      <td>
                        {{ fittingsaleview.shaftinfo.fit_goods_shaft_weight }}
                      </td>
                      <td>
                        {{ fittingsaleview.shaftinfo.fit_goods_shaft_torque }}
                      </td>
                      <td>
                        {{
                          fittingsaleview.shaftinfo.fit_goods_shaft_kickpoint
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center" v-else>
              {{ $t("text.common.no_data") }}
            </div>
          </div>
          <div class="col-lg-6 d-flex flex-column">
            <h6 class="sub-title">{{ $t("title.brandroom.grip") }}</h6>
            <div class="card h-100" v-if="fittingsaleview.gripinfo">
              <div class="card-body p-0">
                <p class="card-title">
                  {{ fittingsaleview.gripinfo.fit_goods_grip_nm }}}
                </p>
                <img
                  :src="
                    fittingsaleview.gripinfo.fit_goods_grip_image1 | get_img
                  "
                  class="card-img-top rounded-0"
                  alt="그립"
                />
              </div>
              <div class="card-footer">
                <table class="table table-sm table-bordered">
                  <thead>
                    <tr>
                      <th scope="col">{{ $t("title.brandroom.standard") }}</th>
                      <th scope="col">{{ $t("title.brandroom.weightg") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {{ fittingsaleview.gripinfo.fit_goods_grip_standard }}
                      </td>
                      <td>
                        {{ fittingsaleview.gripinfo.fit_goods_grip_weight }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="text-center" v-else>
              {{ $t("text.common.no_data") }}
            </div>
          </div>
        </div>
      </section>

      <div class="btn-bottom-wrapper">
        <b-button
          size="xl"
          variant="outline-primary"
          aria-label="목록"
          @click="
            $router.push({
              name: 'SaleList',
              query: { goodstype: $route.query.goodstype },
            })
          "
          >{{ $t("button.brandroom.list") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import locations from "@/components/Location";
import ax from "@/api/fitting";
import "@/filter/common";

export default {
  name: "SaleView",

  data() {
    return {
      fitansno: this.$route.params.fitansno,
      fittingsaleview: {
        adinfo: {
          ad_img1_info: {},
          ad_img2_info: {},
          ad_img3_info: {},
          ad_mov_info: {},
          ad_title_info: {},
        },
        goodsinfo: {},
        memberinfo: {},
        answerinfo: [],
        gripinfo: {},
        shaftinfo: {},
        clubtypelist: [],
      },
    };
  },
  components: {
    locations,
  },
  created() {
    console.log(
      Array.from(
        { length: 20 },
        (x, i) => this.$dayjs(new Date()).format("YYYY") - i
      )
    );
  },
  methods: {
    get_saleview() {
      ax.get_saleview(this.fitansno, (flag, data) => {
        if (flag) {
          this.fittingsaleview = data.fittingsaleview;
          console.log(this.fittingsaleview);
        } else {
          alert(data.message);
        }
      });
    },
  },
  created() {
    this.get_saleview();
  },
};
</script>
